import { mainSiteUrl } from '@/mocks/categories';

export default function ComparisonSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-950">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-14 items-center">
          <div className="w-full lg:w-3/5">
            <span className="inline-block px-3 py-1 rounded-full border border-background-700/50 bg-background-800/30 text-background-300 text-xs font-medium mb-5">
              Why Choose Us
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-background-50 leading-tight mb-5">
              Why Choose Superbuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-background-300 leading-relaxed mb-7">
              Compared to manually searching through marketplaces or relying on scattered social
              media posts, the Superbuy Spreadsheet offers a structured, time-saving approach to
              discovering quality products.
            </p>

            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-700">
                    <th className="text-left py-3 pr-4 text-background-300 font-semibold">Feature</th>
                    <th className="text-left py-3 pr-4 text-background-300 font-semibold">Normal Search</th>
                    <th className="text-left py-3 text-background-100 font-semibold">Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-700/50">
                    <td className="py-3 pr-4 text-background-400">Product Database</td>
                    <td className="py-3 pr-4 text-background-500">Limited</td>
                    <td className="py-3 text-accent-300 font-medium">Extensive</td>
                  </tr>
                  <tr className="border-b border-background-700/50">
                    <td className="py-3 pr-4 text-background-400">Categories</td>
                    <td className="py-3 pr-4 text-background-500">Random</td>
                    <td className="py-3 text-accent-300 font-medium">Organized</td>
                  </tr>
                  <tr className="border-b border-background-700/50">
                    <td className="py-3 pr-4 text-background-400">Updates</td>
                    <td className="py-3 pr-4 text-background-500">Unknown</td>
                    <td className="py-3 text-accent-300 font-medium">Regular</td>
                  </tr>
                  <tr>
                    <td className="py-3 pr-4 text-background-400">Guides</td>
                    <td className="py-3 pr-4 text-background-500">No</td>
                    <td className="py-3 text-accent-300 font-medium">Yes</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="w-full lg:w-2/5 shrink-0">
            <div
              className="w-full aspect-[3/4] rounded-3xl bg-cover bg-center"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20minimal%20fashion%20items%20including%20structured%20handbag%20silk%20scarf%20and%20leather%20gloves%20elegantly%20arranged%20on%20light%20terrazzo%20surface%20with%20warm%20side%20lighting%20casting%20elongated%20soft%20shadows%20high%20end%20luxury%20product%20photography%20editorial%20styling%20sophisticated%20composition&width=500&height=666&seq=comparison-lifestyle-v3&orientation=portrait')`,
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export function CTASection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 mb-4">
          Ready To Shop Smarter?
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-lg mx-auto leading-relaxed">
          Access the complete Superbuy Spreadsheet and start discovering products the smarter way.
          Updated regularly with the latest community-vetted finds.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:border-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap w-full sm:w-auto justify-center"
          >
            Superbuy Sheet
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </div>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap w-full sm:w-auto justify-center"
          >
            Buy It Now
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-14">
        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {['Shoes', 'Hoodies', 'T-Shirts', 'Jackets', 'Bags', 'Accessories', 'Jerseys'].map(
            (tag) => (
              <a
                key={tag}
                href={`https://kaspreadsheet.com/search-91${tag === 'Shoes' ? '1' : tag === 'Hoodies' ? '2' : tag === 'T-Shirts' ? '3' : tag === 'Jackets' ? '4' : tag === 'Bags' ? '1' : tag === 'Accessories' ? '0' : '9'}/name/Shoes.html`}
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 rounded-full bg-background-100 border border-background-200 text-foreground-600 text-xs md:text-sm hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                {tag}
              </a>
            ),
          )}
        </div>
      </div>
    </section>
  );
}